// ===== 新規発行 =====

import { useState } from "react";
import { Stack, Typography, Paper, TextField, Alert, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PageContext } from "../PageContext";
import { useIsOnline } from "../../../util/useIsOnline";

export function IssuanceNewPage({ pageContext }: { pageContext: PageContext }) {
  const api = pageContext.api;
  const isOnline = useIsOnline(api);
  const navigate = useNavigate();
  const [count, setCount] = useState<number>(0);
  const [remarks, setRemarks] = useState<string>("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const submit = async () => {
    if (!count || count < 1) {
      setError("発行枚数は 1 以上を指定してください");
      return;
    }
    if (count > 10000) {
      setError("一度に発行できる枚数は 10000 までです");
      return;
    }
    setSubmitting(true);
    try {
      const res = await api.issuance.put({ material_count: count, remarks: remarks || null });
      navigate(`/console/issuance/${res.id}/`);
    } catch {
      setError("保存に失敗しました。もう一度お試しください");
      setSubmitting(false);
    }
  };

  return (
    <Stack p={3} gap={2} maxWidth={900} mx="auto">
      <Typography variant="h4" fontWeight="bold">発行情報</Typography>
      <Paper variant="outlined" sx={{ p: 3 }}>
        <Stack gap={2} maxWidth={600} mx="auto">
          <TextField type="number" label="発行するQRコードの総数" inputProps={{ min: 1, step: 1 }}
            value={count || ""} onChange={(e) => setCount(Math.max(0, Math.floor(Number(e.target.value) || 0)))} fullWidth />
          <TextField label="備考" multiline minRows={2} value={remarks} onChange={(e) => setRemarks(e.target.value)} fullWidth />
          {error && <Alert severity="error">{error}</Alert>}
          {!isOnline && <Alert severity="warning">新規発行はオンライン限定です(QR番号のサーバー採番が必要なため)。オンラインに復帰してから発行してください。</Alert>}
          <Stack alignItems="center">
            <Button variant="contained" size="large" disabled={submitting || !isOnline} onClick={submit} sx={{ py: 1.5, width: "60%" }}>発行する</Button>
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  );
}
